import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ── Installing the app ──────────────────────────────────────────────────────
//
// ⚠️ THE WORKER USED TO REGISTER ONLY IF YOU TURNED ON NOTIFICATIONS.
// `registerServiceWorker()` in lib/notifications.js is behind `canPush()`, and
// it is called from the push opt-in flow — so for everyone who never enabled
// notifications there was no service worker, and with no service worker Chrome
// on Android never offers "Install app" and never reads the manifest's
// shortcuts. The PWA existed in the files and not on anybody's phone.
//
// ⚠️ GATED ON 'serviceWorker' ONLY, not on PushManager. Registration is what
// makes the app installable; push is a separate capability the same worker
// happens to also provide, and requiring it excluded every browser that
// installs fine but does not do Web Push.
//
// ⚠️ AFTER LOAD, DELIBERATELY. Registering during boot makes the browser fetch
// and start the worker while it is still parsing and painting the app, which
// is the one moment the phone has nothing spare.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Failure is silent on purpose: an unregistered worker costs offline
    // support and the install prompt, and must never stop the app rendering.
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
